import React from 'react'
import { ButtonProps as MuiButtonProps } from '@mui/material/Button'
import CustomButton from 'UI/Button/Button'
import type { ButtonProps as AntButtonProps } from 'antd'

const GenericButton = ({ 
  children, 
  color,
  variant,
  ...props 
}: MuiButtonProps) => {
  const buttonType = variant === 'outlined' ? 'secondary' : 'primary'
  
  return (
    <CustomButton 
      buttonType={buttonType}
      {...props as AntButtonProps}
    >
      {children}
    </CustomButton>
  )
}

export default GenericButton
